/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class PaymentWindowModel {
        constructor(
            private $window: ng.IWindowService,
            private paymentService: services.PaymentService,
            private processId: string,
            private paymentConfigId: string)
        {
            this.getPaymentDetails();
        }

        private getPaymentDetails(): void {
            this.paymentService.getPaymentRequestDetails(this.processId, this.paymentConfigId).then(
                (result: Wars.Domain.Model.Dtos.Payments.PaymentRequestDto) => {
                    this.$window.location.href = result.formActionUrl;
                });
        }
    }
}